export enum READER_RESUME_LOG_EVENT {
    resumeSkippedMissingProgress = 'resume-skipped-missing-progress',
    resumeStarted = 'resume-started',
    resumeTriggered = 'resume-triggered',
    resumeApplied = 'resume-applied',
    authLockAutoTargetMissing = 'auth-lock-auto-target-missing',
    authLockProviderAutoResumeTarget = 'auth-lock-provider-auto-resume-target',
    authLockEmailAutoResumeTarget = 'auth-lock-email-auto-resume-target',
    authLockAutoPathRefreshComplete = 'auth-lock-auto-path-refresh-complete',
    authLockAutoPathSwitch = 'auth-lock-auto-path-switch',
    authLockAutoSeededResumeProgress = 'auth-lock-auto-seeded-resume-progress',
    authLockAutoRetryTriggered = 'auth-lock-auto-retry-triggered',
}
